import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { IControlStyles } from "../../styles";

export const useControlStyles = (theme?: ITheme): IControlStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        button: {
            borderRadius: theme.spaceUnits.sp01,
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.regular,
            padding: theme.spaceUnits.sp02,
            "&:disabled": {
                backgroundColor: theme.palette.disabled.light,
                color: theme.palette.disabled.dark,
            },
            "&:hover": {
                backgroundColor: theme.palette.grey,
                boxShadow: theme.shadowTypes.buttonHover,
            },
        },
        checkbox: {
            fontFamily: theme.font.family,
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.regular,
            textTransform: "none",
            borderColor: theme.palette.grey
        },
        chip: {
            color: "#555A63",
            backgroundColor: "#E6E7E9",
            fontWeight: theme.font.weights.semiBold,
        },
        datagridActionButton: {
        },
        datagridActionButtonIcon: {
            fontSize: theme.font.sizes.lg,
        },
        date: {
            fontFamily: theme.font.family,
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.regular,
            backgroundColor: theme.palette.background.main,
            color: theme.palette.text.main,
            textTransform: "none",
        },
        datetime: {
            fontFamily: theme.font.family,
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.regular,
            backgroundColor: theme.palette.background.main,
            borderColor: theme.palette.divider.main,
            color: theme.palette.text.main,
            textTransform: "none",
        },
        label: {
            fontFamily: theme.font.family,
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.regular,
            color: theme.palette.text.main,
            textTransform: "none",
            backgroundColor: theme.palette.background.transparent,
        },
        optional: {
            fontFamily: theme.font.family,
            fontSize: theme.font.sizes.sm,
            fontStyle: "italic",
            marginLeft: "1px"
        },
        text: {
            fontFamily: theme.font.family,
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.regular,
            color: theme.palette.text.main,
            textTransform: "none",
        },
        textArea: {
            fontFamily: theme.font.family,
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.regular,
            color: theme.palette.text.main,
            textTransform: "none",
            height: "auto"
        }
    }
}